// Import the proxy functions
import { proxyForgeElements, proxyDeconstructElement } from './firebase/elementOperations';
import { proxyGetRandomWord, getRandomWords } from './firebase/goalOperations';

/**
 * Combine two elements using the Firebase Cloud Function
 * @param rule The type of forge (Item, Location, Character)
 * @param element1 The first element
 * @param element2 The second element
 * @returns The result of combining the elements
 */
export async function combineElements(rule: string, element1: string, element2: string) {
  //console.log(
  //  `[API] combineElements called with rule=${rule}, element1=${element1}, element2=${element2}`
  //);

  try {
    //console.log('[API] Calling Cloud Function for combineElements');
    const result = await proxyForgeElements(rule, element1, element2);
    //console.log('[API] Cloud Function result:', result);
    return result;
  } catch (error) {
    console.error('[API] Error in Cloud Function:', error);
    // Instead of returning a fallback, throw an error to be handled by the UI
    throw new Error('Forge operation failed');
  }
}

/**
 * Deconstruct an element using the Firebase Cloud Function
 * @param element The element to deconstruct
 * @param forgeType The type of forge (Item, Location, Character)
 * @returns The components of the deconstructed element
 */
export async function deconstructElement(element: string, forgeType: string) {
  //console.log(`[API] deconstructElement called with element=${element}, forgeType=${forgeType}`);

  try {
    //console.log('[API] Calling Cloud Function for deconstructElement');
    const result = await proxyDeconstructElement(element, forgeType);
    //console.log('[API] Cloud Function result:', result);
    return result;
  } catch (error) {
    console.error('[API] Error in Cloud Function:', error);
    // Instead of returning a fallback, throw an error to be handled by the UI
    throw new Error('Deconstructor operation failed');
  }
}

/**
 * Get a random word for a goal using the Firebase Cloud Function
 * @param type The type of word to get (Item, Location, Character)
 * @param currentWord The current word to exclude
 * @param recentWords A list of recent words to exclude
 * @returns A random word
 */
export async function getRandomWord(
  type: 'Item' | 'Location' | 'Character',
  currentWord: string = '',
  recentWords: string[] = []
): Promise<string> {
  //console.log(`[API] getRandomWord called with type=${type}, currentWord=${currentWord}`);

  try {
    //console.log('[API] Calling Cloud Function for getRandomWord');
    const result = await proxyGetRandomWord(type, currentWord, recentWords);
    //console.log('[API] Cloud Function result:', result);
    return result;
  } catch (error) {
    console.error('[API] Error in Cloud Function:', error);

    // If we have recentWords, use one of them as a fallback
    if (recentWords && recentWords.length > 0) {
      // Pick a random word from the history
      const randomIndex = Math.floor(Math.random() * recentWords.length);
      return recentWords[randomIndex];
    }

    // If no history is available, use default fallbacks
    return type === 'Item' ? 'Sword' : type === 'Location' ? 'Castle' : 'Wizard';
  }
}

// Export the functions
export { getRandomWords };
